<template>
    <Layout>

        <div slot="body" class="main-panel">
            <div class="content-wrapper">
                <div class="row">
                    <div class="col-3">
                        <div class="card">

                            <div class="card-body">
                                <h4 class="card-title">{{getName}}</h4>
                                <p class="card-description"> Intents</p>
                                <button @click="createIntent" class="btn btn-sm btn-success"
                                        style="margin-bottom: 10px"><i class="mdi mdi-plus"></i> New Intent
                                </button>
                                <intent :group_id="groupID" :key="intent_key"
                                        @onIntentSelect="selectIntent"></intent>
                            </div>
                        </div>
                    </div>
                    <div class="col-9">
                        <detail @intent="reload" :group_id="groupID" v-if="selected_intent" :intent="selected_intent" :key="selected_intent.key"
                                :name="selected_intent.name"></detail>
                    </div>
                </div>
            </div>
            <!-- content-wrapper ends -->

        </div>
    </Layout>
</template>

<script>
    import Layout from '../../components/Layout';
    import Loader from "../../components/Loader/Loader";
    import Detail from "../Detail/DetailPage";
    import Intent from "../../components/Intents/Intent.vue";
    import {userService} from '../../services/user.service';

    export default {
        name: "Group",
        props: ['name', 'groupID'],
        components: {Layout, Loader, Detail, Intent},
        data() {
            return {

                loading: false,
                loading_intent: false,
                dashboardData: "",
                groups: [],
                filtered: [],
                intent_key: (Math.random() + 1) * 20,
                detail_key: (Math.random() + 1) * 10 + 4,
                selected: [],
                selected_group: [],
                groupList: [],
                selected_intent: "",
                query: "",
                showChecks: false,
                createNew: false,

            }
        },
        methods: {
            reload(){
                this.intent_key=(Math.random() + 1) * 20
            },
            selectIntent(intent) {

               // this.intent_key=(Math.random() + 1) * 20;
                this.detail_key=(Math.random() + 1) * 40;
                this.selected_intent = intent;
            },
            async createIntent() {

                let inte = prompt("Enter new intent name");

                if (!!inte) {
                    await userService.createGroupIntent(inte, this.groupID)
                        .then((res) => {

                            this.loading = false;
                            // this.dashboardData = res;
                            this.intent_key = (Math.random() + 1) * 14;
                            this.$toastr.success("Success", "Created intent!", {timeOut: 5000});
                           // this.detail_key=(Math.random() + 1) * 40 +Math.random() + 19;
                          //  this.selected_intent=[];

                        }).catch((error) => {

                            this.$toastr.error(error.message, "Error creating intent!", {timeOut: 5000});

                        });
                }


            },

            editIntentName() {
                let newName = prompt("What will you like to call me?");
                if (!!newName) {
                    this.intentName = newName;
                }
            }
        },
        computed: {
            getIntentCount() {
                return this.filtered.length;
            },
            filteredList() {
                return this.filtered.filter(intent => {
                    return intent.group_id === this.id && intent.name.toLowerCase().includes(this.query.toLowerCase())

                })
            },
            getIntent() {
                return this.intents
            },
            getName() {
                return this.intentName ? this.intentName : this.name;
            }
        }
        ,
        mounted() {
            //this.getIntents();
            this.setTitle("Intent -"+this.name);
            console.log(this.groupID);
            //this.intents=this.intent;
        }
    }
</script>

<style scoped>
    .card .card-body {
        padding: 2.5rem 1.5rem;
    }

    .content-wrapper {
        padding: 2.75rem 1.25rem;

    }

    .hang {
        position: absolute;
        top: 10px;
        right: 15px;
    }
</style>
